import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled, { css, keyframes } from 'styled-components'

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`

export const StyledSpinner = styled.div<{ color?: string; size?: string }>`
  ${({ color, size }) => css`
    display: inline-block;
    border-top: 2px solid ${color || tokens.colors.white};
    border-right: 2px solid transparent;
    border-radius: ${tokens.radius.circular};
    width: ${size || '1.1em'};
    height: ${size || '1.1em'};
    animation: ${spin} 0.8s linear infinite;
  `};
`
